import {Component} from '@angular/core';

@Component({
  selector: 'mz-collection-header',
  templateUrl: './collection-header.component.html',
  styleUrls: ['./collection-header.component.scss'],
})
export class MzCollectionHeaderComponent {
}
